/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface CategoryCareerTreePayload {
    isMobile?: boolean;
}

export interface TreeListItem {
    careerType: number;
    checkBoxDisplayFlg: boolean;
    hasChildren: boolean;
    id: string;
    level: string;
    parent: string;
    text: string;
    type: number;
    careerImageUrl?: string;
    children: TreeListItem[];
}

export interface CategoryCareerTreeResponse {
    treeList: TreeListItem[];
}

class CategoryCareerTreeService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "categoryCareerTree");
    }

    public async categoryCareerTree(
        payload: CategoryCareerTreePayload,
        resolved: (json: CategoryCareerTreeResponse) => void,
        rejected: (error: any) => void
    ) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as CategoryCareerTreeResponse;
                resolved(response);
            },
            rejected
        );
    }
}

export default CategoryCareerTreeService;
